import React, { useState, useEffect } from 'react';
import { Row } from 'antd';
import { SearchOutlined } from '@ant-design/icons';

import { TabelaListagem } from './TabelaListagem';
import colors from '../../../../styles/colors';
import { formatString } from '../../../../helpers/utils';

import { useMatrizConsulta } from './context';
import * as S from './styles';

export function Listagem() {
  const { matrizLista } = useMatrizConsulta();
  const [matrizesLista, setMatrizesLista] = useState([]);
  const [inputBusca, setInputBusca] = useState('');

  useEffect(() => {
    setMatrizesLista(matrizLista || []);
  }, [matrizLista]);

  const filtered = matrizesLista.filter(item => {
    if (item?.nome) {
      const concat = item.nome.concat(
        item?.cliente?.nomeFantasia || item?.cliente?.razaoSocial
      );
      return concat.toLowerCase().includes(inputBusca.toLowerCase());
    }
      return null;
  });

  const compare = (a, b) => {
    if (formatString(a.nome) < formatString(b.nome)) return -1;
    if (formatString(a.nome) > formatString(b.nome)) return 1;
    return 0;
  };

  const handleInputBusca = e => {
    setInputBusca(e.target.value);
  };

  return (
    <S.Container height={true}>
      <Row>
        <S.InputSearch
          onChange={handleInputBusca}
          placeholder="Busca"
          prefix={
            <SearchOutlined
              style={{
                color: colors.verde,
                fontSize: 14,
              }}
            />
          }
        />
      </Row>
      <Row
        style={{
          marginTop: 0,
        }}
      >
        <TabelaListagem list={filtered.sort(compare) || []} />
      </Row>
    </S.Container>
  );
}
